<template>
  <div class="header" >
    <img :src="`/imgs/${bg_image_previous}`" :class="bg_previous_class" alt="" v-if="bg_image_previous != ''">
    <img :src="`/imgs/${bg_image_current}`" :class="bg_current_class" alt="">
    <Logo :color_idx="color_idx"></Logo>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue'
import { setTimeout } from 'timers';
export default {
  name: 'Header',
  components: {
    Logo
  },
  props: {
    color_idx: {
      type: String,
      default: 'default'
    },
    bg_image: {
      type: String,
      required: true
    },
    animate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bg_image_current: this.bg_image,
      bg_image_previous: "",
      bg_current_class: "",
      bg_previous_class: ""
    }
  },
  watch: {
    bg_image: function(newVal, oldVal) { 
      let vm = this;
      this.bg_image_current = newVal;
      this.bg_image_previous = oldVal;

      this.bg_previous_class = "bg-img-previous";
      this.bg_current_class = "bg-img-current";

      setTimeout(() => {
        vm.bg_previous_class = "bg-img-previous-after";
        vm.bg_current_class = "";
      }, 500)
    }
  }
}
</script>

<style lang="scss">
  .header {
    width: 100%;
    height: 300px;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    img {
      width: auto;
      position: absolute;
      top: 0;
      left: 50%;
      margin-left: -720px;
      height: 300px;

      opacity: 0.4;

      &.bg-img-previous {
        animation: fadeOut .5s ease-out;
        opacity: 0;
      }
      &.bg-img-previous-after {
        opacity: 0;
      }
      &.bg-img-current  {
        animation: fadeIn .5s ease-out;
      }
    }
  }
  @media screen and (max-width: 768px) {
    .header {
      height: 250px;
      img {
        margin-left: -700px;
        height: 250px;
      }
    }
  }
  @media screen and (max-width: 330px) {
    .header {
      height: 220px;
      img {
        margin-left: -528px;
        height: 220px;
      }
    }
  }
</style>